import React, { useState, useEffect, useRef, FC, useCallback } from 'react';
import { Modal, Button } from '@tencent/tea-component';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import style from './index.module.scss';
import { render } from 'react-dom';
import classNames from 'classnames';

export interface Iprops {
  aspectRatio: number;
  showModal: boolean;
  imgUrl: string;
  onConfirm?: (base64Str: string) => void;
  onCancel?: () => void;
  /** 是否展示最佳信息展示区域 */
  showTip?: boolean;
}
// 裁剪
const CropperModal: FC<Iprops> = (props) => {
  const { imgUrl, showModal, onConfirm, onCancel, aspectRatio = 16 / 9, showTip } = props;
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const cropperRef = useRef<HTMLImageElement>(null);
  const [showText, setShowText] = useState(true);

  const addTip = useCallback(
    (i = 0) => {
      if (i >= 20) return;
      // 刚渲染会拿不到dom，大概100ms左右才可以拿到
      const d: any = document.querySelector('.show-cropper-tip .cropper-dashed.dashed-v');
      if (!d) {
        setTimeout(() => addTip(i + 1), 50);
        return;
      }
      d.style.width = `calc(100% / ${aspectRatio})`;
      render(<div className="tip-content">最佳信息展示区域</div>, d);
    },
    [aspectRatio],
  );

  useEffect(() => {
    setModalVisible(showModal);
  }, [showModal]);
  useEffect(() => {
    if (!modalVisible) {
      setLoading(false);
    }
    if (showTip && modalVisible) {
      addTip();
    }
  }, [modalVisible]);
  const handleCancel = () => {
    if (onCancel) onCancel();
  };
  const handleConfirm = () => {
    if (loading) return;
    setLoading(true);
    const imageElement: any = cropperRef?.current;
    const cropper: any = imageElement?.cropper;
    const dataUrl = cropper
      .getCroppedCanvas({ maxWidth: 2000, maxHeight: 2000 })
      .toDataURL('image/png', 1.0);
    if (onConfirm) onConfirm(dataUrl);
  };
  const onCrop = () => {
    if (!showTip) return;
    const imageElement: any = cropperRef?.current;
    const cropper: any = imageElement?.cropper;
    // 裁剪框拖动的太小的话就把 提示文字隐藏掉
    if (cropper?.getCropBoxData?.()?.width < 236) {
      setShowText(false);
      return;
    }
    setShowText(true);
  };
  return (
    <Modal
      visible={modalVisible}
      onClose={handleCancel}
      caption="上传图片"
      size={850}
      className={style['cropper-modal']}
    >
      <Modal.Body>
        <Cropper
          className={classNames({ 'show-cropper-tip': showTip, 'hide-text': !showText })}
          style={{ height: 450, width: '100%' }}
          src={imgUrl}
          viewMode={1}
          aspectRatio={aspectRatio}
          initialAspectRatio={aspectRatio}
          autoCropArea={1}
          crop={onCrop}
          ref={cropperRef}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button type="weak" style={{ width: '84px' }} onClick={handleCancel}>
          取消
        </Button>
        <Button type="primary" style={{ width: '84px' }} onClick={handleConfirm} loading={loading}>
          保存
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CropperModal;
